import { defineStore }  from 'pinia'
import { ref, computed } from 'vue'
import { useRouter }     from 'vue-router'
import { fetchQRCode, startSession, pollScanStatus, login, logout as apiLogout, fetchMe } from '../services/auth.js'
import { saveSessionId, clearSessionId, getSessionId } from '../services/index.js'

export const useAuthStore = defineStore('auth', () => {
  const router     = useRouter()
  const sessionId  = ref(getSessionId())
  const user       = ref(null)
  const isLoading  = ref(false)
  const qrcode     = ref('')
  const uuid       = ref('')
  const scanStatus = ref(0)
  let   pollTimer  = null

  const isLoggedIn = computed(() => !!sessionId.value)

  async function init() {
    if (!sessionId.value) return
    try { user.value = await fetchMe() }
    catch { sessionId.value = null }
  }

  async function startQRLogin() {
    isLoading.value = true
    try {
      const data   = await fetchQRCode()
      qrcode.value = data.qrcode
      await startSession()
      _startPolling()
    } finally { isLoading.value = false }
  }

  function _startPolling() {
    stopPolling()
    pollTimer = setInterval(async () => {
      try {
        const { status } = await pollScanStatus()
        scanStatus.value = status
        
        if (status === 1) { 
          // 确认成功
          stopPolling()
          await _completeLogin() 
        } else if (status === 2 || status === 3) {
          // 二维码可能已失效，停止轮询让用户主动刷新
          stopPolling()
          scanStatus.value = 5 // 自定义过期状态，以便界面重试
        } else if (status === 5) {
          // 账号异常
          stopPolling()
        }
        // 0, 4, 6 状态都继续轮询
      } catch { stopPolling() }
    }, 2000)
  }

  async function _completeLogin() {
    try {
      const { session_id } = await login()
      saveSessionId(session_id)
      sessionId.value = session_id
      user.value      = await fetchMe()
      router.push('/dashboard')
    } catch (e) {
      console.error('Login failed:', e)
      scanStatus.value = 5 // 遇到错误允许重试
    }
  }

  function stopPolling() {
    if (pollTimer) { clearInterval(pollTimer); pollTimer = null }
  }

  async function logout() {
    try { await apiLogout() } catch {}
    stopPolling()
    clearSessionId()
    sessionId.value = null
    user.value      = null
    router.push('/login')
  }

  window.addEventListener('session:expired', () => {
    sessionId.value = null; user.value = null; router.push('/login')
  })

  return { sessionId, user, isLoading, qrcode, uuid, scanStatus, isLoggedIn, init, startQRLogin, stopPolling, logout }
})
